import React from 'react';

import type { Primitive, SchemaTree } from '../types/offers';

export const schemaToElement = (node: SchemaTree): React.ReactNode => {
  if (node === null || typeof node !== 'object') {
    return node as Primitive;
  }

  if (Array.isArray(node)) {
    return node.map(schemaToElement);
  }

  const { type, key = null, props = {} } = node;
  const { children, ...rest } = props;

  let resolvedChildren: React.ReactNode = null;

  if (Array.isArray(children)) {
    resolvedChildren = children.map(schemaToElement);
  } else if (typeof children === 'object') {
    resolvedChildren = schemaToElement(children);
  } else {
    resolvedChildren = children;
  }

  return React.createElement(type, { ...rest, key }, resolvedChildren);
};
